module.exports = dll_library;